import React, { useState } from 'react';
import { Row, Col, Card, Rate, Tag, Select, Badge, Collapse, Slider, Checkbox, Input, Button } from 'antd';
import { ShoppingCartOutlined, FireOutlined } from '@ant-design/icons';
import BreadCrumb from '../ass_components/BreadCrumb';
import Meta from '../ass_components/Meta';
import { useNavigate } from 'react-router-dom'
import ProductCard from './ProductCard';

const { Option } = Select;
const { Panel } = Collapse;

const Resellers = () => {
  const [grid, setGrid] = useState(4);
  const navigate = useNavigate();

  const productCardProps = [
    {
      id: 1,
      image1: 'images/detail-images/detail1.jpg',
      product_title: 'Soja alvic',
      star_number: 4,
      price: 650,
      available: true,
    },
    {
      id: 2,
      image1: 'images/detail-images/detail22.webp',
      product_title: 'Pomme de terre',
      star_number: 4,
      price: 600,
      available: true,
    },
    {
      id: 3,
      image1: 'images/detail-images/detail3.webp',
      product_title: 'Fruits et legumes',
      star_number: 4,
      price: 900,
      available: true,
    },
    {
      id: 4,
      image1: 'images/detail-images/detail4.jpg',
      product_title: 'Patate douce',
      star_number: 4,
      price: 700,
      available: false,
    }, 
  ];

  return (
    <>
      <Meta title={'En Stock'} />
      <BreadCrumb title='PRODUITS DISPONIBLES' />

      <div className='container-xxl py-5'>
        <Row gutter={24}>
          <Col xs={24} md={6}>
            <Collapse defaultActiveKey={['1', '2']}> 
              <Panel header='Catégories' key='1'>
                <Checkbox.Group style={{ display: 'flex', flexDirection: 'column' }}>
                  <Checkbox value='general'>Général</Checkbox>
                  <Checkbox value='vivrier'>Vivrier</Checkbox>
                  <Checkbox value='transformation'>Transformation</Checkbox>
                  <Checkbox value='mineral'>Minéral</Checkbox>
                </Checkbox.Group>
              </Panel>

              <Panel header='Filtrer par prix (XOF)' key='2'>
                <Slider range defaultValue={[200, 900]} min={100} max={2000} />
              </Panel>

              <Panel header='Meilleures recherches' key='3'>
                <div className='d-flex flex-wrap gap-10'>
                  {['Céréales', 'Grains', 'Légumes', 'Fruits', 'Tubercules', 'Minerais'].map((tag) => (
                    <Tag key={tag}>{tag}</Tag>
                  ))}
                </div>
              </Panel>
            </Collapse>
          </Col>

          <Col xs={24} md={18}>
            <Row justify='space-between' align='middle' style={{ marginBottom: '20px' }}>
              <Col>
                <h4>Afficher par : </h4>
                <Select defaultValue='best-selling' style={{ width: 200, marginLeft: 10 }}>
                  <Option value='best-selling'>Meilleures ventes</Option>
                  <Option value='cheapest'>Bon marché</Option>
                  <Option value='rarest'>Produits rares</Option>
                </Select>
              </Col>
              <Col>
                <span style={{ marginRight: 10 }}>Vue : </span>
                {[3, 4, 6, 12].map((g) => (
                  <Button key={g} onClick={() => setGrid(g)} className="application-button">{g}</Button>
                ))}
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              {productCardProps.map((item) => (
                  <Col xs={24} sm={12} md={24 / grid} key={item.id}>
                  <ProductCard {...item} />
                  </Col>
                  ))}
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Resellers;
